'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cleanStateKey = require('./clean-state-key');

var _cleanStateKey2 = _interopRequireDefault(_cleanStateKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getState = function getState(state, elementKey, value) {
  var key = (0, _cleanStateKey2.default)(elementKey);

  return !!state && !!state._radiumStyleState && !!state._radiumStyleState[key] && state._radiumStyleState[key][value];
};

exports.default = getState;


//////////////////
// WEBPACK FOOTER
// ./~/radium/lib/get-state.js
// module id = 338
// module chunks = 0